import { Tr, Td, IconButton } from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";
import moment from "moment";

// const getColorByPercentage = (percentage) => {
// 	if (percentage >= 80) return '#009900';
// 	if (percentage >= 60 && percentage < 80) return '#55BF3B';
// 	if (percentage >= 20 && percentage < 60) return '#FF9655';
// 	return '#DF5353';
// };

const RecentCheckItem = ({ check, onClick, onDelete }) => {
	// const addressColor = getColorByPercentage(check.percentage);

	return (
		<Tr onClick={() => onClick(check.address)} cursor="pointer">
			<Td isTruncated width="20%" /*color={addressColor} */>
				{`${check.address.slice(0, 6)}...${check.address.slice(-4)}`}
			</Td>
			<Td textAlign="center" width="10%">#{check.rank}</Td>
			<Td textAlign="center" width="10%">{check.marks}</Td>
			<Td textAlign="center" width="15%">Top {Math.ceil(check.percentage)}%</Td>
			<Td textAlign="center" width="20%">{moment(check.timestamp).format('DD MMM YYYY')}</Td>
			<Td width="5%">
				<IconButton
					aria-label="Delete"
					icon={<DeleteIcon />}
					onClick={(e) => {
						e.stopPropagation();
						onDelete(check.address);
					}}
					size="sm"
					colorScheme="red"
					variant="ghost"
					color={"#FF684B"}
					opacity={0.8}
				/>
			</Td>
		</Tr>
	);
};

export default RecentCheckItem;
